<div class="customers-page">
  <customers-table
    [getCustomersFn]="getAllCustomersFn"
    (events)="onCustomersTableEvent($event)">
  </customers-table>
</div>
